import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import { FieldLabel, TextField } from "components/Common/Form"

import { isEmpty } from "helpers/cms_helper"

const NameField = props => {
  const { value, onChange, required, disabled, onError, submitted } = props
  const [val, setVal] = useState({ firstName: "", lastName: "" })
  const [error, setError] = useState({}) // object of {fieldName: "errorMsg"}

  useEffect(() => {
    if (isEmpty(value)) {
      // reset
      setVal({ firstName: "", lastName: "" })
    } else {
      let toSet = _.cloneDeep(value)
      for (const key in toSet) {
        if (isEmpty(toSet[key])) toSet[key] = ""
      }
      setVal(toSet)
    }
  }, [value])

  useEffect(() => {
    for (const key in error) {
      if (!isEmpty(error[key])) return onError(true)
    }
    return onError(false)
  }, [error])

  const handleChange = val => {
    onChange(val)
  }

  const handleError = (fieldName, errorMsg) => {
    setError(prevState => ({ ...prevState, [fieldName]: errorMsg }))
  }

  return (
    <div className="row">
      <div className="col-6">
        <FieldLabel
          name="firstName"
          label="First Name"
          required={required}
          hasError={submitted && !!error.firstName}
        />
        <TextField
          fieldType="custom"
          name="firstName"
          type="text"
          disabled={disabled}
          required={required}
          value={val.firstName}
          onChange={v => handleChange({ ...val, firstName: v })}
          onError={errMsg => handleError("firstName", errMsg)}
          hasError={submitted && !!error.firstName}
        />
        {submitted && error.firstName && (
          <span className="text-danger">{error.firstName}</span>
        )}
      </div>

      <div className="col-6">
        <FieldLabel
          name="lastName"
          label="Last Name"
          required={required}
          hasError={submitted && !!error.lastName}
        />
        <TextField
          fieldType="custom"
          name="lastName"
          type="text"
          disabled={disabled}
          required={required}
          value={val.lastName}
          onChange={v => handleChange({ ...val, lastName: v })}
          onError={errMsg => handleError("lastName", errMsg)}
          hasError={submitted && !!error.lastName}
        />
        {submitted && error.lastName && (
          <span className="text-danger">{error.lastName}</span>
        )}
      </div>
    </div>
  )
}

NameField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  onError: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  submitted: PropTypes.bool,
}

NameField.defaultProps = {
  required: false,
  disabled: false,
  submitted: false,
}

export default NameField
